// import SliderImage from 'assets/images/tests/Happy New Year@2x.png'

export default function init(handler) {
  handler.mock.onGet(/\/v1\/nodes\/slider/).reply(
    200,
    JSON.stringify({
      msg: 'OK',
      code: 200,
      data: {
        nodes: [
          {
            children_type: "",
            created_at: "2019-02-13T14:23:57.717816+03:30",
            deleted_at: null,
            id: "6dbec793-863e-4059-9823-e078b94d538b",
            images: null,
            nodes: null,
            owner_id: "2f09dd39-f82d-4daa-b845-63de98e68e66",
            owner_type: "category",
            parent_id: "c07f2a0d-3b8f-4219-a94a-dbd68ea03045",
            product: null,
            updated_at: "2019-02-13T14:24:05.9854271+03:30",
            category: {
              cover_id: "c531df53-5e4e-4613-9661-ba9ee2151ae2",
              created_at: "2019-02-10T17:19:12.7896895+03:30",
              deleted_at: null,
              description: "",
              id: "2f09dd39-f82d-4daa-b845-63de98e68e66",
              title: "تخفیف بیش از ۴۰٪",
              updated_at: "2019-02-10T17:22:16.6296876+03:30",
              active: true,
              cover: {
                created_at: "2019-02-10T17:21:58.0819874+03:30",
                deleted_at: null,
                description: "",
                id: "c531df53-5e4e-4613-9661-ba9ee2151ae2",
                title: "",
                updated_at: "2019-02-10T17:21:58.0819874+03:30",
                // url: SliderImage,
              }
            }
          },
          {
            children_type: "",
            created_at: "2019-02-13T14:23:57.717816+03:30",
            deleted_at: null,
            id: "cd38943f-35fb-4315-8028-fe2b2364febd",
            images: null,
            nodes: null,
            owner_id: "2f09dd39-f82d-4daa-b845-63de98e68e66",
            owner_type: "category",
            parent_id: "c07f2a0d-3b8f-4219-a94a-dbd68ea03045",
            product: null,
            updated_at: "2019-02-13T14:24:05.9854271+03:30",
            category: {
              cover_id: "c531df53-5e4e-4613-9661-ba9ee2151ae2",
              created_at: "2019-02-10T17:19:12.7896895+03:30",
              deleted_at: null,
              description: "",
              id: "2f09dd39-f82d-4daa-b845-63de98e68e66",
              title: "تخفیف بیش از ۴۰٪",
              updated_at: "2019-02-10T17:22:16.6296876+03:30",
              active: true,
              cover: {
                created_at: "2019-02-10T17:21:58.0819874+03:30",
                deleted_at: null,
                description: "",
                id: "c531df53-5e4e-4613-9661-ba9ee2151ae2",
                title: "",
                updated_at: "2019-02-10T17:21:58.0819874+03:30",
                url: "http://cs123.ir:27907/assets/images/7fde7e26-3b6a-448e-9f72-ee0fd8c481f8.png",
              }
            }
          }
        ]
      }
    })
  )

  handler.mock.onGet(/\/v1\/nodes\/most_popular/).reply(
    200,
    JSON.stringify({
      msg: 'OK',
      code: 200,
      data: {
        nodes: [
          {
            category: null,
            children_type: "",
            created_at: "2018-07-22T20:24:48.7577923+04:30",
            deleted_at: null,
            id: "6a0fafcf-fba1-46ab-8fc3-e77a3611f79b",
            images: null,
            nodes: null,
            owner_id: "2cbb38ab-3190-42b1-b015-e6645b768841",
            owner_type: "product",
            parent_id: "abfb7f3a-e730-4580-ae37-148c97637680",
            updated_at: "2018-07-22T20:24:48.7577923+04:30",
            product: {
              active: true,
              all_barcode: "6261101531013;",
              app_name: "شامپو فرش ا لیتر",
              barcode: "6261101531013",
              brand: "سپید",
              brand_id: "00000000-0000-0000-0000-000000000000",
              consumer_price: 0,
              cover_id: "bda82219-9351-4e55-8e6d-45ab66448d0c",
              created_at: "2018-07-19T12:43:58.1050876+04:30",
              current_discount: 0,
              current_price: 71200,
              deleted_at: null,
              department_code: "",
              department_id: "00000000-0000-0000-0000-000000000000",
              department_name: "",
              description: "",
              discount_flag: true,
              discount_group_id: "00000000-0000-0000-0000-000000000000",
              discount_group_name: "",
              external_id: "10190069",
              gallery: null,
              height: 0,
              id: "2cbb38ab-3190-42b1-b015-e6645b768841",
              language_id: 314,
              last_price: 43050,
              name: "سپید شامپو فرش ا لیتر 12 عدد",
              name_in_pos: "سپید شامپو فرش ا لیتر ",
              parent_id: "00000000-0000-0000-0000-000000000000",
              parent_nodes: null,
              product_type: "",
              quantity: 4,
              report_group_id: "00000000-0000-0000-0000-000000000000",
              report_group_name: "",
              reserved: 0,
              status: "",
              status_id: 243,
              stock_id: "287695d4-6fb8-49cb-b208-6b982749bc3e",
              store_id: 10,
              supplier_id: "00000000-0000-0000-0000-000000000000",
              supplier_name: "",
              tax_group_id: "00000000-0000-0000-0000-000000000000",
              tax_group_name: "",
              tax_percent: 6,
              taxable: true,
              type_id: 237,
              unit_od_measure: "",
              updated_at: "2018-12-12T19:29:57.5490413+03:30",
              weight: 0,
              width: 0,
              cover: {
                created_at: "2018-12-12T19:29:49.1957152+03:30",
                deleted_at: null,
                description: "",
                id: "bda82219-9351-4e55-8e6d-45ab66448d0c",
                title: "6261101531013",
                updated_at: "2018-12-12T19:29:49.1957152+03:30",
                url: "http://cs123.ir:27907/assets/images/bda82219-9351-4e55-8e6d-45ab66448d0c.png",
              }
            }
          },
          {
            category: null,
            children_type: "",
            created_at: "2018-07-22T20:24:48.7577923+04:30",
            deleted_at: null,
            id: "2cbb38ab-3190-42b1-b015-e6645b768841111",
            images: null,
            nodes: null,
            owner_id: "2cbb38ab-3190-42b1-b015-e6645b768841",
            owner_type: "product",
            parent_id: "abfb7f3a-e730-4580-ae37-148c97637680",
            updated_at: "2018-07-22T20:24:48.7577923+04:30",
            product: {
              active: true,
              all_barcode: "6261101531013;",
              app_name: "شامپو فرش ا لیتر",
              barcode: "6261101531013",
              brand: "سپید",
              brand_id: "00000000-0000-0000-0000-000000000000",
              consumer_price: 0,
              cover_id: "bda82219-9351-4e55-8e6d-45ab66448d0c",
              created_at: "2018-07-19T12:43:58.1050876+04:30",
              current_discount: 0,
              current_price: 71200,
              deleted_at: null,
              department_code: "",
              department_id: "00000000-0000-0000-0000-000000000000",
              department_name: "",
              description: "",
              discount_flag: true,
              discount_group_id: "00000000-0000-0000-0000-000000000000",
              discount_group_name: "",
              external_id: "10190069",
              gallery: null,
              height: 0,
              id: "2cbb38ab-3190-42b1-b015-e6645b768841111s",
              language_id: 314,
              last_price: 43050,
              name: "سپید شامپو فرش ا لیتر 12 عدد",
              name_in_pos: "سپید شامپو فرش ا لیتر ",
              parent_id: "00000000-0000-0000-0000-000000000000",
              parent_nodes: null,
              product_type: "",
              quantity: 4,
              report_group_id: "00000000-0000-0000-0000-000000000000",
              report_group_name: "",
              reserved: 0,
              status: "",
              status_id: 243,
              stock_id: "287695d4-6fb8-49cb-b208-6b982749bc3e",
              store_id: 10,
              supplier_id: "00000000-0000-0000-0000-000000000000",
              supplier_name: "",
              tax_group_id: "00000000-0000-0000-0000-000000000000",
              tax_group_name: "",
              tax_percent: 6,
              taxable: true,
              type_id: 237,
              unit_od_measure: "",
              updated_at: "2018-12-12T19:29:57.5490413+03:30",
              weight: 0,
              width: 0,
              cover: {
                created_at: "2018-12-12T19:29:49.1957152+03:30",
                deleted_at: null,
                description: "",
                id: "bda82219-9351-4e55-8e6d-45ab66448d0c",
                title: "6261101531013",
                updated_at: "2018-12-12T19:29:49.1957152+03:30",
                url: "http://cs123.ir:27907/assets/images/bda82219-9351-4e55-8e6d-45ab66448d0c.png",
              }
            }
          },
          {
            category: null,
            children_type: "",
            created_at: "2018-07-22T20:24:48.7577923+04:30",
            deleted_at: null,
            id: "6a0fafcf-fba1-46ab-8fc3-e77a3611f79b2",
            images: null,
            nodes: null,
            owner_id: "2cbb38ab-3190-42b1-b015-e6645b768841",
            owner_type: "product",
            parent_id: "abfb7f3a-e730-4580-ae37-148c97637680",
            updated_at: "2018-07-22T20:24:48.7577923+04:30",
            product: {
              active: true,
              all_barcode: "6261101531013;",
              app_name: "شامپو فرش ا لیتر",
              barcode: "6261101531013",
              brand: "سپید",
              brand_id: "00000000-0000-0000-0000-000000000000",
              consumer_price: 0,
              cover_id: "bda82219-9351-4e55-8e6d-45ab66448d0c",
              created_at: "2018-07-19T12:43:58.1050876+04:30",
              current_discount: 0,
              current_price: 71200,
              deleted_at: null,
              department_code: "",
              department_id: "00000000-0000-0000-0000-000000000000",
              department_name: "",
              description: "",
              discount_flag: true,
              discount_group_id: "00000000-0000-0000-0000-000000000000",
              discount_group_name: "",
              external_id: "10190069",
              gallery: null,
              height: 0,
              id: "2cbb38ab-3190-42b1-b015-e6645b7688412",
              language_id: 314,
              last_price: 43050,
              name: "سپید شامپو فرش ا لیتر 12 عدد",
              name_in_pos: "سپید شامپو فرش ا لیتر ",
              parent_id: "00000000-0000-0000-0000-000000000000",
              parent_nodes: null,
              product_type: "",
              quantity: 4,
              report_group_id: "00000000-0000-0000-0000-000000000000",
              report_group_name: "",
              reserved: 0,
              status: "",
              status_id: 243,
              stock_id: "287695d4-6fb8-49cb-b208-6b982749bc3e",
              store_id: 10,
              supplier_id: "00000000-0000-0000-0000-000000000000",
              supplier_name: "",
              tax_group_id: "00000000-0000-0000-0000-000000000000",
              tax_group_name: "",
              tax_percent: 6,
              taxable: true,
              type_id: 237,
              unit_od_measure: "",
              updated_at: "2018-12-12T19:29:57.5490413+03:30",
              weight: 0,
              width: 0,
              cover: {
                created_at: "2018-12-12T19:29:49.1957152+03:30",
                deleted_at: null,
                description: "",
                id: "bda82219-9351-4e55-8e6d-45ab66448d0c",
                title: "6261101531013",
                updated_at: "2018-12-12T19:29:49.1957152+03:30",
                url: "http://cs123.ir:27907/assets/images/bda82219-9351-4e55-8e6d-45ab66448d0c.png",
              }
            }
          },
          {
            category: null,
            children_type: "",
            created_at: "2018-07-22T20:24:48.7577923+04:30",
            deleted_at: null,
            id: "6a0fafcfssss-fba1-46ab-8fc3-e77a3611f79b",
            images: null,
            nodes: null,
            owner_id: "2cbb38ab-3190-42b1-b015-e6645b768841",
            owner_type: "product",
            parent_id: "abfb7f3a-e730-4580-ae37-148c97637680",
            updated_at: "2018-07-22T20:24:48.7577923+04:30",
            product: {
              active: true,
              all_barcode: "6261101531013;",
              app_name: "شامپو فرش ا لیتر",
              barcode: "6261101531013",
              brand: "سپید",
              brand_id: "00000000-0000-0000-0000-000000000000",
              consumer_price: 0,
              cover_id: "bda82219-9351-4e55-8e6d-45ab66448d0c",
              created_at: "2018-07-19T12:43:58.1050876+04:30",
              current_discount: 0,
              current_price: 71200,
              deleted_at: null,
              department_code: "",
              department_id: "00000000-0000-0000-0000-000000000000",
              department_name: "",
              description: "",
              discount_flag: true,
              discount_group_id: "00000000-0000-0000-0000-000000000000",
              discount_group_name: "",
              external_id: "10190069",
              gallery: null,
              height: 0,
              id: "2cbb38ab-3190-42b1-b015-e6645b768841",
              language_id: 314,
              last_price: 43050,
              name: "سپید شامپو فرش ا لیتر 12 عدد",
              name_in_pos: "سپید شامپو فرش ا لیتر ",
              parent_id: "00000000-0000-0000-0000-000000000000",
              parent_nodes: null,
              product_type: "",
              quantity: 4,
              report_group_id: "00000000-0000-0000-0000-000000000000",
              report_group_name: "",
              reserved: 0,
              status: "",
              status_id: 243,
              stock_id: "287695d4-6fb8-49cb-b208-6b982749bc3e",
              store_id: 10,
              supplier_id: "00000000-0000-0000-0000-000000000000",
              supplier_name: "",
              tax_group_id: "00000000-0000-0000-0000-000000000000",
              tax_group_name: "",
              tax_percent: 6,
              taxable: true,
              type_id: 237,
              unit_od_measure: "",
              updated_at: "2018-12-12T19:29:57.5490413+03:30",
              weight: 0,
              width: 0,
              cover: {
                created_at: "2018-12-12T19:29:49.1957152+03:30",
                deleted_at: null,
                description: "",
                id: "bda82219-9351-4e55-8e6d-45ab66448d0c",
                title: "6261101531013",
                updated_at: "2018-12-12T19:29:49.1957152+03:30",
                url: "http://cs123.ir:27907/assets/images/bda82219-9351-4e55-8e6d-45ab66448d0c.png",
              }
            }
          }
        ]
      }
    })
  )

  handler.mock.onGet(/\/v1\/nodes\/most_off/).reply(
    200,
    JSON.stringify({
      msg: 'OK',
      code: 200,
      data: {
        nodes: [
          {
            category: null,
            children_type: "",
            created_at: "2018-07-22T20:24:48.7577923+04:30",
            deleted_at: null,
            id: "6a0fafcf-fba1-46ab-8fc3-e77a3611f79b",
            images: null,
            nodes: null,
            owner_id: "2cbb38ab-3190-42b1-b015-e6645b768841",
            owner_type: "product",
            parent_id: "abfb7f3a-e730-4580-ae37-148c97637680",
            updated_at: "2018-07-22T20:24:48.7577923+04:30",
            product: {
              active: true,
              all_barcode: "6261101531013;",
              app_name: "شامپو فرش ا لیتر",
              barcode: "6261101531013",
              brand: "سپید",
              brand_id: "00000000-0000-0000-0000-000000000000",
              consumer_price: 0,
              cover_id: "bda82219-9351-4e55-8e6d-45ab66448d0c",
              created_at: "2018-07-19T12:43:58.1050876+04:30",
              current_discount: 0,
              current_price: 71200,
              deleted_at: null,
              department_code: "",
              department_id: "00000000-0000-0000-0000-000000000000",
              department_name: "",
              description: "",
              discount_flag: true,
              discount_group_id: "00000000-0000-0000-0000-000000000000",
              discount_group_name: "",
              external_id: "10190069",
              gallery: null,
              height: 0,
              id: "2cbb38ab-3190-42b1-b015-e6645b768841",
              language_id: 314,
              last_price: 43050,
              name: "سپید شامپو فرش ا لیتر 12 عدد",
              name_in_pos: "سپید شامپو فرش ا لیتر ",
              parent_id: "00000000-0000-0000-0000-000000000000",
              parent_nodes: null,
              product_type: "",
              quantity: 4,
              report_group_id: "00000000-0000-0000-0000-000000000000",
              report_group_name: "",
              reserved: 0,
              status: "",
              status_id: 243,
              stock_id: "287695d4-6fb8-49cb-b208-6b982749bc3e",
              store_id: 10,
              supplier_id: "00000000-0000-0000-0000-000000000000",
              supplier_name: "",
              tax_group_id: "00000000-0000-0000-0000-000000000000",
              tax_group_name: "",
              tax_percent: 6,
              taxable: true,
              type_id: 237,
              unit_od_measure: "",
              updated_at: "2018-12-12T19:29:57.5490413+03:30",
              weight: 0,
              width: 0,
              cover: {
                created_at: "2018-12-12T19:29:49.1957152+03:30",
                deleted_at: null,
                description: "",
                id: "bda82219-9351-4e55-8e6d-45ab66448d0c",
                title: "6261101531013",
                updated_at: "2018-12-12T19:29:49.1957152+03:30",
                url: "http://cs123.ir:27907/assets/images/bda82219-9351-4e55-8e6d-45ab66448d0c.png",
              }
            }
          }
        ]
      }
    })
  )
}
